import { render, staticRenderFns } from "./FieldListItem2.vue?vue&type=template&id=c2c87e5a&scoped=true&"
import script from "./FieldListItem2.vue?vue&type=script&lang=js&"
export * from "./FieldListItem2.vue?vue&type=script&lang=js&"
import style0 from "./FieldListItem2.vue?vue&type=style&index=0&id=c2c87e5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c87e5a",
  null
  
)

export default component.exports